{
  "app": {
    "title": "Lebenslauf & Anschreiben Creator"
  },
  "tabs": {
    "resume": "Lebenslauf",
    "coverLetter": "Anschreiben",
    "settings": "Einstellungen"
  },
  "actions": {
    "exportPdf": "PDF exportieren",
    "downloadPdf": "PDF herunterladen",
    "importJson": "JSON importieren",
    "exportJson": "JSON exportieren",
    "clearAll": "Alles löschen",
    "clearAllTitle": "Alle Daten löschen?",
    "clearAllConfirm": "Alle eingegebenen Daten (Lebenslauf, Anschreiben, Design-Einstellungen) werden unwiderruflich gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "clearAllCancel": "Abbrechen",
    "add": "Hinzufügen",
    "remove": "Entfernen"
  },
  "basics": {
    "title": "Persönliche Daten",
    "name": "Name",
    "label": "Berufsbezeichnung",
    "email": "E-Mail",
    "phone": "Telefon",
    "url": "Webseite",
    "summary": "Profiltext",
    "birthDate": "Geburtsdatum",
    "birthPlace": "Geburtsort",
    "nationality": "Nationalität",
    "image": "Foto",
    "imageUpload": "Foto hochladen",
    "imageUrlPlaceholder": "oder Bild-URL eingeben",
    "imageRemove": "Foto entfernen",
    "imageInvalidType": "Bitte ein Bild (PNG, JPEG oder WebP) auswählen.",
    "address": "Straße",
    "postalCode": "PLZ",
    "city": "Stadt",
    "countryCode": "Land (ISO)"
  },
  "photo": {
    "shape": "Form",
    "shape_circle": "Rund",
    "shape_rounded": "Abgerundet",
    "shape_square": "Eckig",
    "size": "Größe",
    "size_sm": "Klein",
    "size_md": "Mittel",
    "size_lg": "Groß"
  },
  "summary": {
    "description": "Profiltext"
  },
  "work": {
    "position": "Titel der Stelle",
    "company": "Arbeitgeber",
    "startDate": "Anfangsdatum",
    "endDate": "Enddatum",
    "location": "Stadt",
    "currentlyWorking": "Aktuell hier beschäftigt",
    "description": "Beschreibung"
  },
  "education": {
    "degree": "Abschluss",
    "institution": "Bildungseinrichtung",
    "fieldOfStudy": "Fachrichtung",
    "grade": "Note",
    "startDate": "Anfangsdatum",
    "endDate": "Enddatum",
    "location": "Stadt",
    "description": "Beschreibung"
  },
  "contact": {
    "profiles": "Profile & Links",
    "network": "Netzwerk",
    "username": "Benutzername",
    "profileUrl": "Link (URL)",
    "selectNetwork": "Netzwerk wählen",
    "displayStyle_icons": "Nur Icons",
    "displayStyle_text": "Nur Text",
    "displayStyle_both": "Beide"
  },
  "skills": {
    "name": "Kenntnis",
    "level": "Niveau",
    "level_beginner": "Grundkenntnisse",
    "level_elementary": "Grundlegende Kenntnisse",
    "level_intermediate": "Gute Kenntnisse",
    "level_upper_intermediate": "Fortgeschritten",
    "level_advanced": "Sehr gute Kenntnisse",
    "level_proficient": "Verhandlungssicher",
    "level_expert": "Experte",
    "groupName": "Gruppe",
    "addSkill": "Kenntnis",
    "addGroup": "Gruppe",
    "addChild": "Kenntnis hinzufügen",
    "childPlaceholder": "z.B. React, Node.js",
    "columns": "Spalten"
  },
  "languages": {
    "language": "Sprache",
    "fluency": "Niveau",
    "fluency_a1": "Grundkenntnisse",
    "fluency_a2": "Erweiterte Grundkenntnisse",
    "fluency_b1": "Gute Kenntnisse",
    "fluency_b2": "Fließend in Wort und Schrift",
    "fluency_c1": "Verhandlungssicher",
    "fluency_c2": "Annähernd muttersprachlich",
    "fluency_native": "Muttersprache"
  },
  "projects": {
    "name": "Projektname",
    "url": "URL",
    "startDate": "Anfangsdatum",
    "endDate": "Enddatum",
    "description": "Beschreibung",
    "keywords": "Technologien",
    "keywordsPlaceholder": "React, TypeScript, Node.js"
  },
  "certificates": {
    "name": "Zertifikatsname",
    "issuer": "Aussteller",
    "date": "Datum",
    "url": "URL"
  },
  "interests": {
    "name": "Interesse"
  },
  "custom": {
    "sectionTitle": "Abschnittstitel",
    "itemHeading": "Überschrift",
    "itemBody": "Inhalt",
    "addItem": "Eintrag hinzufügen",
    "addSection": "Abschnitt hinzufügen"
  },
  "coverLetterEditor": {
    "title": "Anschreiben",
    "senderTitle": "Absender",
    "recipientTitle": "Empfänger",
    "company": "Firma",
    "name": "Name",
    "address": "Adresse",
    "postalCode": "PLZ",
    "city": "Stadt",
    "country": "Land",
    "email": "E-Mail",
    "phone": "Telefon",
    "metaTitle": "Brief-Details",
    "place": "Ort",
    "date": "Datum",
    "subject": "Betreff",
    "reference": "Referenz / Kennziffer",
    "referencePlaceholder": "z.B. Ihre Stellenanzeige vom 01.04.2026, Kennziffer STL-2026-42",
    "bodyTitle": "Brieftext",
    "salutation": "Anrede",
    "salutationPlaceholder": "Sehr geehrte Damen und Herren,",
    "paragraphs": "Absätze",
    "addParagraph": "+ Absatz hinzufügen",
    "removeParagraph": "Absatz entfernen",
    "closingTitle": "Abschluss & Unterschrift",
    "closing": "Grußformel",
    "closingPlaceholder": "Mit freundlichen Grüßen",
    "signatureName": "Name (Unterschrift)",
    "signatureImage": "Unterschriftsbild",
    "uploadSignature": "Unterschrift hochladen",
    "removeSignature": "Unterschrift entfernen",
    "signatureTooLarge": "Das Bild ist zu groß (max. 2 MB).",
    "signatureInvalidType": "Bitte ein Bild (PNG, JPEG oder WebP) auswählen.",
    "signatureUploadMode": "Hochladen",
    "signatureDrawMode": "Zeichnen",
    "signaturePadClear": "Löschen",
    "signaturePadApply": "Übernehmen",
    "showFoldMarks": "Falz- und Lochmarken anzeigen",
    "showSenderInfo": "Absenderadresse im Informationsblock anzeigen",
    "din5008Form": "Briefform (DIN 5008)",
    "formA": "Form A — Kompakt (27mm)",
    "formB": "Form B — Standard (45mm)"
  },
  "sections": {
    "personal": "Persönliche Daten",
    "summary": "Profil",
    "experience": "Berufserfahrung",
    "education": "Bildungsweg",
    "skills": "Kenntnisse",
    "languages": "Sprachen",
    "projects": "Projekte",
    "certificates": "Zertifikate",
    "publications": "Publikationen",
    "awards": "Auszeichnungen",
    "volunteer": "Ehrenamt",
    "interests": "Interessen",
    "references": "Referenzen",
    "custom": "Weitere"
  },
  "documentTypes": {
    "lebenslauf": "Lebenslauf",
    "anschreiben": "Anschreiben",
    "cv": "CV"
  },
  "slots": {
    "sidebar": "Seitenleiste",
    "main": "Hauptbereich",
    "header": "Kopfzeile",
    "kopfzeile": "Kopfzeile",
    "fusszeile": "Fußzeile",
    "footer": "Fußzeile"
  },
  "editor": {
    "noEntries": "Noch keine Einträge.",
    "entry": "Eintrag",
    "entries": "Einträge",
    "addComponent": "+ Komponente hinzufügen",
    "emptySlot": "Keine Komponenten in diesem Bereich. Füge eine hinzu.",
    "noForm": "Kein Editor für diese Komponente verfügbar."
  },
  "settings": {
    "uiLocale": "Sprache der Benutzeroberfläche"
  },
  "support": {
    "link": "Unterstützen"
  },
  "preview": {
    "page": "Seite",
    "pages": "Seiten",
    "rendering": "Wird gerendert…",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "zoomReset": "Zoom zurücksetzen",
    "showPreview": "Vorschau anzeigen",
    "showEditor": "Editor anzeigen"
  },
  "designer": {
    "colors": "Farben",
    "colorPrimary": "Akzent",
    "colorSecondary": "Sekundär",
    "colorSidebarBg": "Seitenleiste",
    "colorText": "Text",
    "colorMuted": "Gedämpft",
    "colorBorder": "Rahmen",
    "shuffleColors": "Farben mischen",
    "palette_navy": "Marine Klassisch",
    "palette_ocean": "Ozeanblau",
    "palette_cobalt": "Kobalt",
    "palette_steel": "Stahlblau",
    "palette_midnight": "Mitternacht",
    "palette_slate": "Schiefer Minimal",
    "palette_charcoal": "Anthrazit",
    "palette_graphite": "Graphit",
    "palette_teal": "Petrol",
    "palette_forest": "Waldgrün",
    "palette_emerald": "Smaragd",
    "palette_sage": "Salbei",
    "palette_olive": "Olive",
    "palette_burgundy": "Burgunder",
    "palette_terracotta": "Terrakotta",
    "palette_copper": "Kupfer",
    "palette_sienna": "Sienna",
    "palette_coral": "Koralle",
    "palette_espresso": "Espresso",
    "palette_purple": "Königslila",
    "palette_indigo": "Indigo",
    "palette_mauve": "Mauve",
    "palette_plum": "Pflaume",
    "palette_rose": "Rose",
    "palette_airbus": "Airbus",
    "fonts": "Schriften",
    "fontHeading": "Überschrift",
    "fontBody": "Fließtext",
    "spacing": "Abstände",
    "spacing_compact": "Kompakt",
    "spacing_normal": "Normal",
    "spacing_spacious": "Großzügig",
    "borderStyle": "Rahmenstil",
    "sectionTitleStyle": "Titelstil",
    "titleStyle_uppercase-spaced": "GROSSBUCHSTABEN",
    "titleStyle_normal": "Normal",
    "titleStyle_accent-bar": "Akzent-Balken",
    "titleStyle_accent-underline": "Akzent-Unterstrich",
    "skillDisplay": "Kenntnisse-Anzeige",
    "skillMode_text": "Text",
    "skillMode_bar": "Balken",
    "skillMode_stars": "Sterne",
    "skillMode_dots": "Punkte",
    "slots": "Bereiche",
    "moveUp": "Nach oben",
    "moveDown": "Nach unten",
    "remove": "Entfernen",
    "addComponent": "+ Komponente hinzufügen"
  },
  "toolbar": {
    "design": "Design",
    "language": "Sprache",
    "customize": "Anpassen",
    "customizeTitle": "Design anpassen"
  }
}
